import React from 'react';
import { Download, Upload, Plus, GitPullRequest } from 'lucide-react';
import type { User } from '../../../../shared/types/index.js';

interface BookListHeaderProps {
  user: User | null;
  onOpenExportModal: () => void;
  onOpenImportModal: () => void;
  onAddBook: () => void;
  onOpenFlowGuide?: () => void;
}

export const BookListHeader: React.FC<BookListHeaderProps> = ({
  user,
  onOpenExportModal,
  onOpenImportModal,
  onAddBook,
  onOpenFlowGuide,
}) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h2 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight">
          Katalog & Manajemen Buku UIBN
        </h2>
        <p className="text-xs sm:text-sm text-slate-500 mt-0.5">
          Kelola nomor unik UIBN, barcode, metadata buku, dan ekspor data katalog.
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-2.5 shrink-0">
        {onOpenFlowGuide && (
          <button
            type="button"
            onClick={onOpenFlowGuide}
            className="h-10 px-3.5 text-xs font-semibold bg-indigo-50 hover:bg-indigo-100 text-indigo-700 border border-indigo-200/80 rounded-xl shadow-2xs transition flex items-center gap-1.5 cursor-pointer"
            title="Lihat Panduan 2 Cara Alur Pengajuan UIBN (Akun Penulis vs Akun Penerbit)"
          >
            <GitPullRequest className="w-4 h-4 text-indigo-600" />
            <span>Alur Pengajuan</span>
          </button>
        )}

        <button
          id="btn-export-csv"
          type="button"
          onClick={onOpenExportModal}
          className="h-10 px-4 text-xs font-bold bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 rounded-xl shadow-2xs transition flex items-center gap-2 cursor-pointer"
        >
          <Download className="w-4 h-4 text-slate-500" />
          <span>Ekspor CSV</span>
        </button>

        {user && (
          <button
            id="btn-import-csv"
            type="button"
            onClick={onOpenImportModal}
            className="h-10 px-4 text-xs font-bold bg-white hover:bg-slate-50 text-indigo-600 border border-indigo-200 rounded-xl shadow-2xs transition flex items-center gap-2 cursor-pointer"
          >
            <Upload className="w-4 h-4 text-indigo-500" />
            <span>Impor Massal (CSV)</span>
          </button>
        )}

        <button
          id="btn-add-book"
          type="button"
          onClick={onAddBook}
          className="h-10 px-4 text-xs font-bold bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 text-white rounded-xl shadow-xs transition flex items-center gap-2 cursor-pointer"
        >
          <Plus className="w-4 h-4" />
          <span>Daftar Buku & Generate UIBN</span>
        </button>
      </div>
    </div>
  );
};
